import { render, staticRenderFns } from "./ArtGuideEventsReorderControlHandle.vue?vue&type=template&id=f82c64a6&scoped=true&"
var script = {}
import style0 from "./ArtGuideEventsReorderControlHandle.vue?vue&type=style&index=0&id=f82c64a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82c64a6",
  null
  
)

export default component.exports